import styled from 'styled-components';

const Rows = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 20px 20px;
`;

export default Rows;
